module.exports = require('./bundle-url').getBundleURL() + "plockledemo4.46005ab8.jpg"